<template>
  <div>
    <paragraph class="pb-5 text-sm">・CSVエクスポートには、広告費の高い順に上位5万行のみが含まれます。
    </paragraph>
    <vx-card>
      <data-table
        :column-defs="columnDefs"
        :default-col-def="defaultColDef"
        :row-data="keywordReports"
        :total="total"
        pagination
        :current-page="currentPage"
        :pagination-page-size="pageSize"
        @update:current-page="onUpdateCurrentPage"
        @update:pagination-page-size="onUpdatePaginationPageSize"
      >
        <template #actions>
          <select-field
            v-model="dateRange"
            name="期間"
            class="mr-3"
            :options="dateRanges"
            placeholder="期間"
          />
          <select-field
            v-model="selectedMatchTypes"
            name="マッチタイプ"
            class="mr-3"
            :options="matchTypes"
            placeholder="マッチタイプ"
            multiple
          />
          <vs-button
            class="csv-export-button"
            @click="onCSVExportClick"
          >
            CSVエクスポート
          </vs-button>
        </template>
      </data-table>
    </vx-card>
  </div>
</template>
  
  <script>
  import moment from 'moment'
  import { mapActions, mapState } from 'vuex'
  import DataTable from '@/components/table/DataTable'
  import SelectField from '@/components/fields/SelectField'
  import Paragraph from '@/components/Paragraph'
  import { debounce } from '@/utils'
  
  export default {
    name: 'KeywordReports',
    components: {
      SelectField,
      DataTable,
      Paragraph
    },
    data () {
      return {
        dateRange: 'thisMonth',
        selectedMatchTypes: [],
        currentPage: 1,
        total: 0,
        pageSize: 50,
        defaultColDef: {
          sortable: false,
          editable: false,
          resizable: true,
          suppressMenu: true
        },
        columnDefs: [
          {
            headerName: 'アドタイプ',
            field: 'adType',
            width: 110
          },
          {
            headerName: '月',
            field: 'date',
            width: 130
          },
          {
            headerName: 'キャンペーン名',
            field: 'campaignName'
          },
          {
            headerName: '広告グループ名',
            field: 'adGroupName'
          },
          {
            headerName: 'キーワードテキスト/ターゲティングテキスト',
            field: 'keywordText',
            width: 300
          },
          {
            headerName: 'マッチタイプ',
            field: 'matchType'
          },
          {
            headerName: 'カスタマーの検索キーワード',
            field: 'query',
            pinned: 'left',
            width: 210
          },
          {
            headerName: 'ターゲティングタイプ',
            field: 'targetingType'
          },
          {
            headerName: 'ターゲティング詳細',
            field: 'targetingExpression'
          },
          {
            headerName: 'インプレッション',
            field: 'impressions',
            width: 150
          },
          {
            headerName: '費用',
            field: 'cost',
            width: 150
          },
          {
            headerName: 'クリック',
            field: 'clicks',
            width: 150
          },
          {
            headerName: '広告がクリックされてから1日以内の注文の合計',
            field: 'attributedConversions1d',
            width: 310
          },
          {
            headerName: '広告がクリックされてから7日以内の注文の合計',
            field: 'attributedConversions7d',
            width: 310
          },
          {
            headerName: '広告がクリックされてから14日以内の注文の合計',
            field: 'attributedConversions14d',
            width: 320
          },
          {
            headerName: '広告がクリックされてから30日以内の注文の合計',
            field: 'attributedConversions30d',
            width: 320
          },
          {
            headerName: '広告がクリックされてから1日以内の宣伝ASINの注文',
            field: 'attributedConversions1dSameSku',
            width: 340
          },
          {
            headerName: '広告がクリックされてから7日以内の宣伝ASINの注文',
            field: 'attributedConversions7dSameSku',
            width: 340
          },
          {
            headerName: '広告がクリックされてから14日以内の宣伝ASINの注文',
            field: 'attributedConversions14dSameSku',
            width: 350
          },
          {
            headerName: '広告がクリックされてから30日以内の宣伝ASINの注文',
            field: 'attributedConversions30dSameSku',
            width: 350
          },
          {
            headerName: '広告がクリックされてから1日以内の販売個数',
            field: 'attributedUnitsOrdered1d',
            width: 300
          },
          {
            headerName: '広告がクリックされてから7日以内の販売個数',
            field: 'attributedUnitsOrdered7d',
            width: 300
          },
          {
            headerName: '広告がクリックされてから14日以内の販売個数',
            field: 'attributedUnitsOrdered14d',
            width: 310
          },
          {
            headerName: '広告がクリックされてから30日以内の販売個数',
            field: 'attributedUnitsOrdered30d',
            width: 310
          },
          {
            headerName: '広告がクリックされてから1日以内の宣伝ASINの販売個数',
            field: 'attributedUnitsOrdered1dSameSku',
            width: 370
          },
          {
            headerName: '広告がクリックされてから7日以内の宣伝ASINの販売個数',
            field: 'attributedUnitsOrdered7dSameSku',
            width: 370
          },
          {
            headerName: '広告がクリックされてから14日以内の宣伝ASINの販売個数',
            field: 'attributedUnitsOrdered14dSameSku',
            width: 380
          },
          {
            headerName: '広告がクリックされてから30日以内の宣伝ASINの販売個数',
            field: 'attributedUnitsOrdered30dSameSku',
            width: 380
          },
          {
            headerName: '広告がクリックされてから1日以内の総売上高',
            field: 'attributedSales1d',
            width: 310
          },
          {
            headerName: '広告がクリックされてから7日以内の総売上高',
            field: 'attributedSales7d',
            width: 310
          },
          {
            headerName: '広告がクリックされてから14日以内の総売上高',
            field: 'attributedSales14d',
            width: 310
          },
          {
            headerName: '広告がクリックされてから30日以内の総売上高',
            field: 'attributedSales30d',
            width: 310
          },
          {
            headerName: '広告がクリックされてから1日以内の宣伝ASINの売上げ',
            field: 'attributedSales1dSameSku',
            width: 360
          },
          {
            headerName: '広告がクリックされてから7日以内の宣伝ASINの売上げ',
            field: 'attributedSales7dSameSku',
            width: 360
          },
          {
            headerName: '広告がクリックされてから14日以内の宣伝ASINの売上げ',
            field: 'attributedSales14dSameSku',
            width: 370
          },
          {
            headerName: '広告がクリックされてから30日以内の宣伝ASINの売上げ',
            field: 'attributedSales30dSameSku',
            width: 370
          }
        ]
      }
    },
    computed: {
      ...mapState('keywordReport', ['keywordReports']),
      dateRanges () {
        return [
          {
            text: '今月',
            value: 'thisMonth'
          },
          {
            text: '先月',
            value: 'lastMonth'
          }
        ]
      },
      matchTypes () {
        return [
          {
            text: '完全一致',
            value: 'EXACT'
          },
          {
            text: 'フレーズ一致',
            value: 'PHRASE'
          },
          {
            text: '部分一致',
            value: 'BROAD'
          },
          {
            text: 'asin',
            value: 'asin'
          },
          {
            text: 'asin-expanded',
            value: 'asin-expanded'
          },
          {
            text: 'category',
            value: 'category'
          },
          {
            text: 'auto',
            value: 'auto'
          },
          {
            text: 'auto-close',
            value: 'auto-close'
          },
          {
            text: 'auto-loose',
            value: 'auto-loose'
          },
          {
            text: 'auto-substitutes',
            value: 'auto-substitutes'
          },
          {
            text: 'auto-complements',
            value: 'auto-complements'
          },
          {
            text: 'similar-product',
            value: 'similar-product'
          },
          {
            text: 'views-exact',
            value: 'views-exact'
          },
          {
            text: 'views-similar',
            value: 'views-similar'
          },
          {
            text: 'views-category',
            value: 'views-category'
          },
          {
            text: 'purchases-exact',
            value: 'purchases-exact'
          },
          {
            text: 'purchases-related',
            value: 'purchases-related'
          },
          {
            text: 'purchases-category',
            value: 'purchases-category'
          },
          {
            text: 'その他',
            value: 'other'
          }
        ]
      },
      startDay () {
        if (this.dateRange === 'thisMonth') return moment().startOf('month').format()
        if (this.dateRange === 'lastMonth') return moment().subtract(1, 'months').startOf('month').format()
        return null
      },
      endDay () {
        if (this.dateRange === 'thisMonth') return moment().endOf('month').format()
        if (this.dateRange === 'lastMonth') return moment().subtract(1, 'months').endOf('month').format()
        return null
      }
    },
    watch: {
      selectedMatchTypes: {
        handler () {
          this.filterReport()
        },
        deep: true
      },
      dateRange: {
        handler () {
          this.selectedMatchTypes = []
        }
      }
    },
    methods: {
      ...mapActions('keywordReport', ['fetchkeywordReports', 'downloadUnionAllCSV']),
      filterReport: debounce(function () {
        this.getReport()
      }, 1000),
      async getReport () {
        try {
          const payload = {
            start_day: this.startDay.split('T')[0],
            end_day: this.endDay.split('T')[0],
            page: this.currentPage,
            per_page: this.pageSize,
          }
          if (this.selectedMatchTypes.length > 0) {
            payload['match_types'] = JSON.stringify(this.selectedMatchTypes)
          }
          const res = await this.fetchkeywordReports(payload)
          this.total = res.data.total
        } catch (e) {
          console.log(e)
        }
      },
      onUpdateCurrentPage (val) {
        this.currentPage = val
        this.getReport()
      },
      onUpdatePaginationPageSize (val) {
        this.currentPage = 1
        this.pageSize = val
        this.getReport()
      },
      dateChange () {
        this.currentPage = 1
        this.getReport()
      },
      async onCSVExportClick () {
        try {
          const payload = {
            start_day: this.startDay.split('T')[0],
            end_day: this.endDay.split('T')[0],
          }
          if (this.selectedMatchTypes.length > 0) {
            payload['match_types'] = JSON.stringify(this.selectedMatchTypes)
          }
          await this.downloadUnionAllCSV(payload)
        } catch (e) {
          console.log(e)
        }
      }
    }
  }
  
  </script>
  
  <style scoped>
  .csv-export-button {
    max-height: 40px;
  }
  </style>
  